/**
 * Created by Ning Jiang on 8/31/2017.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WildNudgeGameConfig} from "../WildNudgeGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {CounterViewData, CounterView} from "./CounterView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {TweenLite, TimelineLite} from "gsap";

export class MultiplierIndicator extends BaseView {

    public static readonly UPDATE_MULTIPLIER:string = "MultiplierEvent_UpdateMultiplier";

    private _currentMultiplier:number;
    private _endMultiplier:number;
    private _layer:PIXI.Container;
    private _foregroundLayer:PIXI.Container;
    private _multiplierStripeObject:CounterView;
    private _isWin:boolean;
    private _lights:PIXI.Sprite[] = [];
    private _lightsOn:boolean[] = [false, false, false, false, false, false, false, false, false, false];
    private _extraLids:PIXI.Sprite;

    constructor() {
        super();

        this._currentMultiplier = 1;
        this._layer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.MULTIPLIER.name);
        this._foregroundLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.FOREGROUND.name);

        let nVDataObject:CounterViewData = {
            imageAssetPrefix : "mult_",
            digits : 2,
            value : 1,
            imageTopMargin : 6,
            frameHeight : 85,
            frameWidth : 40,
            digitPadding : 5,
            animationDuration : 0.1,
            maskHeight : 135,
            maskWidth : 40,
            maskY : -25,
        };
        this._multiplierStripeObject = new CounterView(nVDataObject);
        this.addChild(this._multiplierStripeObject);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onSpinStart());

        EventHandler.addEventListener(this, MultiplierIndicator.UPDATE_MULTIPLIER, (event:GameEvent) => this.onUpdate(event.params[0]));
    }


    private onServerDataParsed(data:ParsedGameData):void{
        this._isWin = data.singleWin > 0;
        this._endMultiplier = data.currentMultiplier;
    }

    protected initAnimations():void {
        for(let i = 0; i < 10; i++){
            this._lights.push(new PIXI.Sprite(GameResources.getTextures("lightBulb")[0]));
            this._lights[i].position.set(995, 439 - i * 31);
            this._lights[i].blendMode = PIXI.BLEND_MODES.ADD;
            this._lights[i].alpha = 0;
            this._foregroundLayer.addChild(this._lights[i]);
        }

        //first light is on
        this.turnLightOn(0);

        const background:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("multiplierBg")[0]);
        this.addChild(background);

        this._multiplierStripeObject.position.set(52, 35);
        this.addChild(this._multiplierStripeObject);

        this._layer.addChild(this);

        this._extraLids = new PIXI.Sprite(GameResources.getTextures("extraLid")[0]);
        this._layer.addChild(this._extraLids);

        this.updateText();
    }

    private turnLightOn(index:number){
        if(!this._lightsOn[index]){
            TweenLite.fromTo(this._lights[index], 0.3, {alpha: 0}, {alpha: 1});
            this._lightsOn[index] = true;
        }
    }

    private turnLightOff(index:number){
        if(this._lightsOn[index]){
            TweenLite.fromTo(this._lights[index], 0.3, {alpha: 1}, {alpha: 0});
            this._lightsOn[index] = false;
        }
    }

    protected onSpinStart():void {
        this._currentMultiplier = 1;
        const timer:TimelineLite = new TimelineLite();
        if(this._isWin){
            timer.add(() => {
                this._multiplierStripeObject.setCounterValue(this._currentMultiplier);
                for(let i:number = 1; i < 10; i++) {
                    this.turnLightOff(i);
                }
            }, 0.5);
        }
    }

    private updateText():void {
        if(this._isWin){
            this._multiplierStripeObject.setCounterValue(this._currentMultiplier);
            for(let i:number = 0; i < this._currentMultiplier; i++){
                this.turnLightOn(i);
            }
        }
    }

    private onUpdate(number?:number):void {
        if(number == null) {
            this._currentMultiplier++;
        } else {
            this._currentMultiplier = number;
        }

        if(this._currentMultiplier > this._endMultiplier) {
            debugger;
            throw new Error(`MultiplierIndicator.onUpdate():currentMultiplier cannot be bigger than endMultiplier!`);
        }

        this.updateText();
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            this.position.set(733, -143);
            this._extraLids.position.set(1085, 11);
        } else {
            this.position.set(1085, 11);
            this._extraLids.position.set(739, -143);
        }
    }
}